import { useSearchParams } from 'react-router';

import { DRAFT_QUERY_KEY } from '@jane/bloom/utils/queryParams/queryParams';

/**
 * Helpers to determine if a retailer is previewing draft changes
 * to their Bloom theme.
 */

/** Compatible with a Remix (Node) request */
export const isDraft = (request: Request) => {
  const draftParam = new URL(request.url).searchParams.get(DRAFT_QUERY_KEY);
  return draftParam === 'true';
};

export const useIsDraft = () => {
  const [searchParams] = useSearchParams();
  return searchParams.get(DRAFT_QUERY_KEY) === 'true';
};
